import React from "react";

import TrueIcon from "@mui/icons-material/Done";
import Typography from "@mui/material/Typography";
import { useRecordContext } from "react-admin";

type Props = {
  source?: string;
  sortable?: boolean;
};

export const CheckedOnlyField = (props: Props) => {
  const record = useRecordContext();
  const { source } = props;
  if (!record || !source) {
    return null;
  }

  const value = record[source];
  return (
    <Typography variant="body2" component="span">
      {value && <TrueIcon fontSize="small" />}
    </Typography>
  );
};
